import React from 'react'
import { useStyles } from './styles'

interface OtpInputProps {
  code: string[]
  disabled?: boolean
  onChange: (index: number, value: string) => void
  onKeyDown: (index: number, e: React.KeyboardEvent<HTMLInputElement>) => void
  onPaste: (e: React.ClipboardEvent<HTMLInputElement>) => void
  setRef: (index: number, el: HTMLInputElement | null) => void
}

export const OtpInput: React.FC<OtpInputProps> = ({ code, disabled = false, onChange, onKeyDown, onPaste, setRef }) => {
  const styles = useStyles()

  return (
    <div className={styles.otpInputs}>
      {code.map((digit, index) => (
        <input
          key={index}
          ref={(el) => setRef(index, el)}
          type='text'
          inputMode='numeric'
          maxLength={1}
          value={digit}
          onChange={(e) => onChange(index, e.target.value)}
          onKeyDown={(e) => onKeyDown(index, e)}
          onPaste={onPaste}
          disabled={disabled}
          className={styles.otpInput}
          autoFocus={index === 0}
        />
      ))}
    </div>
  )
}
